import * as Types from '@frameio/graphql-client/generated/types';

import { TypedDocumentNode as DocumentNode } from '@graphql-typed-document-node/core';
import gql from 'graphql-tag';
import { FieldValueBase } from '../../../../utils/gql/generated/FieldValueBase';

import { useQuery, useLazyQuery, useMutation, useFragment, useSubscription } from '@apollo/client';
import type { QueryHookOptions, LazyQueryHookOptions, MutationHookOptions, SubscriptionHookOptions, UseFragmentOptions } from '@apollo/client';

export type DateFieldValueFragment = { __typename?: 'AssetFieldValue', id: string, fieldType: Types.FieldTypeEnum, valueLength?: number | null, isValueTrimmed?: boolean | null, value: { __typename?: 'DateFieldValue', date?: string | null } | { __typename?: 'DerivedFieldValue' } | { __typename?: 'JsonFieldValue' } | { __typename?: 'LinkFieldValue' } | { __typename?: 'LongTextFieldValue' } | { __typename?: 'NumberFieldValue' } | { __typename?: 'RatingFieldValue' } | { __typename?: 'SelectFieldValue' } | { __typename?: 'SelectMultiFieldValue' } | { __typename?: 'TextFieldValue' } | { __typename?: 'ToggleFieldValue' } | { __typename?: 'UrlFieldValue' } | { __typename?: 'UserMultiFieldValue' } | { __typename?: 'UserSingleFieldValue' } | { __typename?: 'UsersFieldValue' }, fieldDefinition: { __typename?: 'ProjectFieldDefinition', id: string } };

export const DateFieldValue = /*#__PURE__*/ gql`
    fragment DateFieldValue on AssetFieldValue {
  ...FieldValueBase
  value {
    ... on DateFieldValue {
      date
    }
  }
}
    ${FieldValueBase}` as unknown as DocumentNode<DateFieldValueFragment, unknown>;

        

        
export const useDateFieldValueFragment = (
  input: string | Omit<UseFragmentOptions<DateFieldValueFragment, any>, 'fragment' | 'fragmentName'> | undefined | null
) => {
  const options = (() => {
    if (!input) return { from: null };
    if (typeof input === 'string') return { from: { id: input, __typename: 'AssetFieldValue' } };
    return input;
  })();

  return useFragment<DateFieldValueFragment>({
    fragment: DateFieldValue,
    fragmentName: 'DateFieldValue',
    ...options,
  });
};
  
        